var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.93,98.81H2.05c-1.1,0-2-.9-2-2s.9-2,2-2h94.88c1.1,0,2,.9,2,2s-.9,2-2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.78,4.35h0ZM64.34,4.77h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.66,74.24l-1.9,8.47-1.5,6.51c-.02.09-.01.17,0,.26-.05.32.05.64.28.87.19.19.44.29.7.29.08,0,.16,0,.23-.03l15.41-3.72-13.22-12.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.67,12.25l-6.2-5.83c-2.13-2-5.49-1.88-7.65.29l-58.59,58.66-7.3,7.3,13.55,12.96.03-.03h0s.01-.01.01-.01l58.46-58.46c.06-.06.1-.14.14-.21l7.5-7.51c1.01-1.01,1.57-2.38,1.55-3.77-.02-1.32-.55-2.53-1.49-3.41Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.0679fe89bd014c5580b5a7663c4bd289.svg";
export { ForwardRef as ReactComponent };